import 'bootstrap-sass/assets/javascripts/bootstrap.js';
import 'react-fastclick';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { getForbidden } from 'app-policies';
import { isMobile } from 'constants';
import Alerts from 'modules/alerts/alerts';
import ForbiddenPage from 'routes/forbidden/forbidden-page';
import MainMenu from 'components/main-menu/main-menu';
import Modal from 'modules/modals/modal';
import RightPane from 'components/right-pane/right-pane';
import Timers from 'modules/timers/timers';
import TriageNotification from 'components/widgets/triage-notification/triage-notification';

import * as layoutActions from './store/actions';
import { useTaskTemplates } from '../../routes/ticket/store/actions';

const environment = process.env.ENVIRONMENT;

// Component
function PageLayout({ children, path, settings, currentUser, menuPosition, rightPaneCollapsed }) {
  const forbidden = getForbidden(path, currentUser);
  const isDashboard = _.startsWith(path, '/dashboard');
  const hasCurrentUser = _.get(currentUser, 'id');
  useTaskTemplates({ notifyOnChangeProps: [] });

  if (isDashboard) return <div className="dashboard">{children}</div>;

  return (
    <div>
      { environment && !_.includes(['Live', 'Dev'], environment) &&
        <div className="environment-indicator">
          <h2>{process.env.ENVIRONMENT}</h2>
          <h3>Do not use this site unless instructed to do so</h3>
          <a href="https://portal.praece.com">Take me to the real Portal v4!</a>
        </div>
      }
      <Modal />
      <MainMenu
        currentUser={currentUser}
        menuPosition={menuPosition}
        settings={settings}
        {...layoutActions}
      />
      <div>
        <div id="content" className={classNames({ expand: rightPaneCollapsed })}>
          <Alerts />
          { !_.isEmpty(currentUser) && (forbidden ? <ForbiddenPage /> : children) }
          { hasCurrentUser && !isMobile && <Timers /> }
        </div>
      </div>
      <RightPane {...layoutActions} />
      { isMobile && <TriageNotification openRightPane={layoutActions.openRightPane} /> }
    </div>
  );
}

PageLayout.propTypes = {
  children: PropTypes.node,
  currentUser: PropTypes.object,
  path: PropTypes.string,
  settings: PropTypes.object,
  menuPosition: PropTypes.number,
  rightPaneCollapsed: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    currentUser: state.auth.currentUser,
    path: state.location.pathname,
    settings: state.pageData.settings,
    menuPosition: state.layout.menu.position,
    rightPaneCollapsed: state.layout.rightPane.collapsed
  };
}

export default connect(mapStateToProps)(PageLayout);



// WEBPACK FOOTER //
// ./app/modules/page-layout/page-layout.js